import styled from 'styled-components';
import { getBodyStyle, getColor, type Theme } from 'styles/theme';
import Link from 'components/Globals/Base/Link';
import AuthorBio from 'components/AuthorBio';

export const ContributorWrapper = styled.div<{ theme: Theme }>`
  position: relative;
`;

export const ContributorDetails = styled.div<{ theme: Theme }>`
  display: flex;
  gap: 8px;
  max-width: 288px;
  letter-spacing: 0.5px;
  line-height: 21px;
`;

export const ContributorInformation = styled.span<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'small' })};
  color: ${getColor('textPrimary')};
  display: flex;
  flex-direction: column;

  .checkmark {
    margin: 0 8px -3px 0; 
    min-height: 16px;
    min-width: 16px;
    &:hover {
      filter: none;
    }
  }
`;

export const InfoText = styled.span<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'small' })};
  color: ${getColor('textPrimary')};
  text-transform: uppercase;
`;

export const Name = styled(Link)<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'small' }, 'semiBold')};
  color: ${getColor('textPrimary')};
  text-transform: uppercase;
`;

export const Role = styled.span<{ theme: Theme }>`
  font-weight: 400;
  color: ${getColor('textSecondary')};
`;

export const Tooltip = styled(AuthorBio)<{ $tooltipOpen: boolean }>`
  visibility: ${(props) => (props.$tooltipOpen ? 'visible' : 'hidden')};
  position: absolute;
  z-index: 9998;
  margin-top: 10px;

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 16px;
    top: -16px;
    left: 0;
  }
`;
